import React from 'react';
import { Space } from 'antd';
import { I18n } from '@aws-amplify/core';

import { BaseModal } from './shared/BaseModal';
import { PrimaryButton } from '@/components/ui/Button';
import type { SuccessModalProps } from './shared/types';
import * as Typography from '@/components/Settings/DataExtraction/styles';
import * as S from './styles';

export function SuccessModal({
	visible = false,
	extractionName = '',
	onGoToHome,
	onCancel
}: Readonly<SuccessModalProps>) {
	return (
		<BaseModal visible={visible} onCancel={onCancel} footer={false} centered>
			<Space direction="vertical" size={24} align="center" style={{ width: '100%' }}>
				<S.SuccessIcon />
				<Typography.LabelMediumRegular>
					{`${I18n.get('Extraction')} "${extractionName}" ${I18n.get(
						'has been added to the queue and will be available for download on the home page soon'
					)}.`}
				</Typography.LabelMediumRegular>
				<PrimaryButton type="primary" onClick={onGoToHome}>
					{I18n.get('Go to home page')}
				</PrimaryButton>
			</Space>
		</BaseModal>
	);
}
